package com.partejar.app.core.ui.theme

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.staticCompositionLocalOf

internal val LocalStatusBarOverride = staticCompositionLocalOf<MutableState<Boolean?>?> { null }

/** A screen owns only its status-bar override; the theme remains the single platform writer. */
@Composable
internal fun PartejarStatusBarAppearance(lightIcons: Boolean?) {
    val override = LocalStatusBarOverride.current ?: return
    DisposableEffect(override, lightIcons) {
        override.value = lightIcons
        onDispose { override.value = null }
    }
}

@Composable
internal expect fun PartejarSystemBars(
    darkTheme: Boolean,
    lightStatusBarIcons: Boolean = darkTheme
)
